import { React, useContext, useState, useCallback ,useEffect} from "react";
import Slider from "react-slick";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomArrows from "./CustomArrows";
import SingleProducts from "./SingleProduct";
import { AccountContext } from "../contexts/AccountContext";
import { path } from "../urls";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SliderPlaceholder from "../assets/images/singleProduct.png";
import SliderPlace from "../assets/images/product.png";
import { FaAngleRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import useDevice from "./useDevice";


function WidgetsLoop({ widget, ishome = true }) {
  const [accountState] = useContext(AccountContext);
  const [dragging, setDragging] = useState(false);
  const location = useLocation();
  const [state, dispatchAccount] = useContext(AccountContext);
  const { pathname } = location;
const router=useNavigate();
const width=useDevice();

  const maincategoriesSetting = {
    speed: 200,
    slidesToShow: parseInt(widget.column_per_view, 10),
    rows: parseInt(widget.row_number, 10),
    slidesToScroll: parseInt(widget.column_number, 10),
    infinite: true,
  };

  const source_type = (() => {
    if (pathname === "/") return "home";
    if (pathname.includes("c=")) return "category";
    if (pathname.includes("s=")) return "seller";
    if (pathname.includes("m=")) return "manufacturer";
    if (pathname.startsWith("/latest")) return "new_arrival";
    return "home";
  })();

  const [isBigScreen, setIsBigScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsBigScreen(width >= 1500);
    };

    window.addEventListener("resize", checkScreenSize);
    checkScreenSize(); 

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);


  const source_type_id = (() => {
    const lastSegment = pathname.split("/").pop();

    if (!lastSegment) return "";

    if (lastSegment.includes("=")) {
      const [key, value] = lastSegment.split("=");
      if (["p", "s", "m", "c"].includes(key)) {
        return value;
      }
    }

    return lastSegment;
  })();


  function hexToRgba(hex, opacity) {
    hex = hex.replace('#', '');
  
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
  
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  
  const types = {
    1: "product",
    2: "category",
    3: "manufacturer",
    4: "seller",
  };

  const setting = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: <CustomArrows direction={"l"} type={"slider"} />,
    nextArrow: <CustomArrows direction={"r"} type={"slider"} />,
  };

  const carousal = {
    // dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    lazyLoad: true,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: <CustomArrows direction={"l"} type={"carousel"} />,
    nextArrow: <CustomArrows direction={"r"} type={"carousel"} />,
  };

  const grid = {
    // dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    lazyLoad: true,
    // autoplay: true,
    // autoplaySpeed: 4000,
    prevArrow: <CustomArrows direction={"l"} type={"grid"} />,
    nextArrow: <CustomArrows direction={"r"} type={"grid"} />,
  };
  const productMobile = {
    dots: false,
    speed: 200,
    slidesToShow:
      widget?.type === "banner"
        ? widget?.display === "carousal"
          ? 2
          : widget.column_number - 0.5
        : 2,
    swipeToSlide: true,
    infinite: false,
    arrows: false,
    lazyLoad: true,
  };
  const home = ishome;

  const productSetting = {
    dots: home,
    speed: 200,
    slidesToShow: widget?.items?.length < 4 ? widget?.items?.length : 5,
    slidesToScroll: 4,
    infinite: true,
    prevArrow: <CustomArrows direction={"l"} />,
    nextArrow: <CustomArrows direction={"r"} />,
  };

  const handleBeforeChange = useCallback(() => {
    setDragging(true);
  }, [setDragging]);

  const handleAfterChange = useCallback(() => {
    setDragging(false);
  }, [setDragging]);

  const handleOnItemClick = useCallback(
    (e) => {
      if (dragging) {
        // e.stopPropagation()
        e.preventDefault();
      }
    },
    [dragging]
  );

  return (
    <div className="">
      {" "}
      {/* <h1>{window.innerWidth}</h1> */}
      {widget.display === "slider" && (
        <Slider {...setting}>
          {widget?.items?.map((item, index) =>
            item.mobile_type_id === "0" ? (
              <div data-index={index} key={`slider` + index}>
                <img
                  alt={item.name}
                  src={`${window.config["site-url"]}/image/` + item.image}
                  className="w-full"
                  // width={widget.banner_width}
                  height={widget.banner_height}
                  //  height={window.innerWidth * widget.banner_height/widget.banner_width}
                  placeholderSrc={SliderPlaceholder}
                />
              </div>
            ) : (
              <div>
                <Link
                  key={index}
                  to={
                    // accountState.admin
                    //   ? `${path}/${types[item.mobile_type]}/${
                    //       item.mobile_type_id
                    //     }`
                    //   :
                    item?.name?.length > 0
                      ? "/" +
                        item.name
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replace("/", "-")
                          .replace("%", "") +
                        "/" +
                        types[item?.mobile_type]?.slice(0, 1) +
                        "=" +
                        item.mobile_type_id
                      : "cat/c=" + item.mobile_type_id
                  }
                  state={{
                    banner_id: item.banner_id,
                    banner_image_id: item.banner_image_id,
                    source_type: source_type,
                    source_type_id: source_type_id,
                  }}
                >
                  {/* <LazyLoadImage
                
                /> */}

                  <div>
                    <LazyLoadImage
                      alt={item.name}
                      src={`${window.config["site-url"]}/image/` + item.image}
                      className="w-full h-full"
                      width={widget.banner_width}
                      // placeholderSrc={SliderPlaceholder}
                    />
                  </div>
                </Link>
              </div>
            )
          )}
        </Slider>
      )}
      {/* view all button */}
      {widget?.display === "carousel" && (
        <div
          style={{
            background: `${
              widget.background_color == "#000000"
                ? "white"
                : widget.background_color
            }`,
            color: `${
              widget.background_color == "#000000" ? "black" : "white"
            }`,
          }}
          className={`flex items-center px-7 ${
            widget.view_title ? "justify-between" : "justify-end"
          }`}
        >
          {widget.view_title!=="0" && (
            <h1
              className="pr-semibold p-2 text-xl ml-16"
              dangerouslySetInnerHTML={{ __html: widget.title }}
            />
          )}
          {widget.view_all !== "0" && (
            <div>
              {widget.type === "seller" ? (
                <a
                  href={
                    widget.filters !== false && widget.filters !== ""
                      ? "/" +
                        widget.title
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replaceAll("/", "-")
                          .replace("%", "") +
                        "/s=" +
                        widget.type_id +
                        "?has_filter=true" +
                        (widget?.filters?.filter_categories
                          ? "&filter_categories=" +
                            widget?.filters?.filter_categories.map(
                              (fc) => fc.id
                            )
                          : "") +
                        (widget?.filters?.filter_manufacturers
                          ? "&filter_manufacturers=" +
                            widget?.filters?.filter_manufacturers.map(
                              (fm) => fm.id
                            )
                          : "") +
                        (widget?.filters?.filter_sellers
                          ? "&filter_sellers=" +
                            widget?.filters?.filter_sellers.map((fs) => fs.id)
                          : "") +
                        (widget?.filters?.filter_options
                          ? "&filter_options=" +
                            widget?.filters?.filter_options.map((fo) => fo.id)
                          : "")
                      : "/" +
                        widget.title
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replaceAll("/", "-")
                          .replace("%", "") +
                        "/s=" +
                        widget.type_id
                  }
                >
                  <h1 className="font-bold text-xs relative overflow-hidden px-2 py-1 group cursor-pointer hover:opacity-80 flex items-center">
                    <div className=" h-[0.15rem] w-0 bg-dblack1 absolute group-hover:w-full transition-all left-0 bottom-0"></div>
                    VIEW AL{" "}
                    <FaAngleRight className="mr-1 ml-1 translate-x-0  duration-300  transition-all group-hover:translate-x-1" />
                  </h1>
                </a>
              ) : widget.type === "category" ? (
                <a
                  className=" block"
                  href={
                    widget.filters !== false && widget.filters !== ""
                      ? "/" +
                        widget.title
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replaceAll("/", "-")
                          .replace("%", "") +
                        "/c=" +
                        widget.type_id +
                        "?has_filter=true" +
                        (widget?.filters?.filter_categories
                          ? "&filter_categories=" +
                            widget?.filters?.filter_categories.map(
                              (fc) => fc.id
                            )
                          : "") +
                        (widget?.filters?.filter_manufacturers
                          ? "&filter_manufacturers=" +
                            widget?.filters?.filter_categories.map(
                              (fm) => fm.id
                            )
                          : "") +
                        (widget?.filters?.filter_sellers
                          ? "&filter_sellers=" +
                            widget?.filters?.filter_sellers.map((fs) => fs.id)
                          : "") +
                        (widget?.filters?.filter_options
                          ? "&filter_options=" +
                            widget?.filters?.filter_options.map((fo) => fo.id)
                          : "")
                      : "/" +
                        widget.title
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replaceAll("/", "-")
                          .replace("%", "") +
                        "/c=" +
                        widget.type_id
                  }
                >
                  <h1 className="font-bold text-sm relative overflow-hidden px-2 py-1 group cursor-pointer hover:opacity-80 flex items-center">
                    <div className=" h-[0.15rem] w-0 bg-dblack1 absolute group-hover:w-full transition-all left-0 bottom-0"></div>
                    VIEW ALL{" "}
                    <FaAngleRight className="mr-1 ml-1 translate-x-0  duration-300  transition-all group-hover:translate-x-1" />
                  </h1>
                </a>
              ) : (
                <a
                  href={
                    widget.type === "new_arrival"
                      ? "/latest"
                      : widget.filters !== false && widget.filters !== ""
                      ? "/" +
                        widget.title
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replaceAll("/", "-")
                          .replace("%", "") +
                        "/c=" +
                        widget.type_id +
                        "?has_filter=true" +
                        (widget?.filters?.filter_categories
                          ? "&filter_categories=" +
                            widget?.filters?.filter_categories.map(
                              (fc) => fc.id
                            )
                          : "") +
                        (widget?.filters?.filter_manufacturers
                          ? "&filter_manufacturers=" +
                            widget?.filters?.filter_manufacturers.map(
                              (fm) => fm.id
                            )
                          : "") +
                        (widget?.filters?.filter_sellers
                          ? "&filter_sellers=" +
                            widget?.filters?.filter_sellers.map((fs) => fs.id)
                          : "") +
                        (widget?.filters?.filter_options
                          ? "&filter_options=" +
                            widget?.filters?.filter_options.map((fo) => fo.id)
                          : "")
                      : "/" +
                        widget.title
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replaceAll("/", "-")
                          .replace("%", "") +
                        "/c=" +
                        widget.type_id
                  }
                >
                  <h1 className="font-bold text-sm relative overflow-hidden px-2 py-1 group cursor-pointer hover:opacity-80 flex items-center">
                    <div className=" h-[0.15rem] w-0 bg-dblack1 absolute group-hover:w-full transition-all left-0 bottom-0"></div>
                    VIEW ALL{" "}
                    <FaAngleRight className="mr-1 ml-1 translate-x-0  duration-300  transition-all group-hover:translate-x-1" />
                  </h1>
                </a>
              )}
            </div>
          )}
        </div>
      )}
      {widget.display === "carousel" &&  widget.type !== "widget_recommended" &&(
        <div
          style={{
            background: `${
              widget.background_color == "#000000"
                ? "white"
                : widget.background_color
            }`,
          }}
          className="px-10"
        >
          {window.innerWidth > 650 ? (
            <Slider
              {...(widget.items[0]?.product_id ? productSetting : carousal)}
              beforeChange={handleBeforeChange}
              afterChange={handleAfterChange}
              className={`carousel ${
                widget.background_color == "#000000" ? "nobg" : "bg"
              } flex-row-reverse`}
              style={{ Height: widget.banner_height + "px" }}
            >
              {widget.items?.map((item) => {
                if (item.product_id) {
                  return (
                    <div
                      className=" grid grid-flow-col p-3"
                      key={item.product_id}
                    >
                      <SingleProducts
                        className=""
                        item={item}
                        click={handleOnItemClick}
                        dragging={dragging}
                      ></SingleProducts>
                    </div>
                  );
                } else {
                  return (
                    <div
                      className={`p-1 cursor-pointer hover:opacity-80  place-items-center w-1/${widget.column_number} md:w-1/${widget.column_number} `}
                      key={item.banner_image_id}
                    >
                      <Link
                        to={`${
                          // accountState.admin
                          //   ? path +
                          //     "/" +
                          //     types[item.mobile_type] +
                          //     "/" +
                          //     item.mobile_type_id
                          //   :

                          item?.name?.length > 0
                            ? "/" +
                              item.name
                                .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                .replace(/\s+/g, "-")
                                .replace("/", "-")
                                .replace("/", "-") +
                              "/" +
                              types[item.mobile_type].slice(0, 1) +
                              "=" +
                              item.mobile_type_id
                            : "cat/c=" + item.mobile_type_id
                        }`}
                        state={{
                          banner_id: item.banner_id,
                          banner_image_id: item.banner_image_id,
                          source_type: source_type,
                          source_type_id: source_type_id,
                        }}
                        onClickCapture={handleOnItemClick}
                      >
                        <LazyLoadImage
                          alt={item.name}
                          // src={
                          //   `${window.config["site-url"]}/image/` +
                          //   item.image
                          // }
                          src={
                            `https://www.englishhome.com.lb/image/` + item.image
                          }
                          className="w-full"
                          //  width={widget.banner_width}
                          // height={widget.banner_height}
                          title={item.name}
                          placeholdersrc={SliderPlace}
                        />
                      </Link>
                    </div>
                  );
                }
              })}
            </Slider>
          ) : (
            <Slider {...productMobile}>
              {widget?.items?.map((item) => {
                if (item?.product_id) {
                  return (
                    <div className="pr-2" key={item.product_id}>
                      <SingleProducts
                        // likedData={likedData}
                        item={item}
                      ></SingleProducts>
                    </div>
                  );
                } else {
                  return (
                    <div className={`pr-2`} key={item.banner_image_id}>
                      <Link>
                        <LazyLoadImage
                          alt={item.name}
                          src={
                            `https://www.englishhome.com.lb/image/` + item.image
                          }
                          width={item.banner_width}
                          height={item.banner_height}
                          title={item.name}
                        />
                      </Link>
                    </div>
                  );
                }
              })}
            </Slider>
          )}
        </div>
      )}
      {widget.display === "grid" && widget.type !== "widget_recommended" && widget.items.length > 1 && (
  <div
    className="grid justify-center py-5 gap-4 px-5"
    style={{
      gridTemplateColumns: `repeat(${widget.column_number}, minmax(0, 1fr))`,
    }}
  >
    {widget?.items?.map((item, index) => {
      const linkPath =
        item?.name?.length > 0
          ? "/" +
            item?.name
              ?.replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
              .replace("%", "")
              .replace(/\s+/g, "-")
              .replace("/", "-") +
            "/" +
            types[item?.mobile_type]?.slice(0, 1) +
            "=" +
            item.mobile_type_id
          : "cat/c=" + item.mobile_type_id;

      return item.mobile_type_id !== "0" ? (
        <Link
          key={index}
          className="w-full"
          to={linkPath}
          state={{
            banner_id: item.banner_id,
            banner_image_id: item.banner_image_id,
            source_type: source_type,
            source_type_id: source_type_id,
          }}
        >
            <div className="relative flex flex-col items-center">
          <LazyLoadImage
            className="w-full"
            alt={item.name}
            src={`https://www.englishhome.com.lb/image/${item.image}`}
            width={item.banner_width}
            height={item.banner_height}
          />
            <h1
            className="text-center text-[17px] pr-semibold"
            dangerouslySetInnerHTML={{ __html: item?.title }}
          />
          </div>

        </Link>
      ) : (
        <div key={index} className="w-full">
          <LazyLoadImage
            className="w-full"
            alt={item.name}
            src={`https://www.englishhome.com.lb/image/${item.image}`}
          />
        </div>
      );
    })}
  </div>
)}


   {widget?.display === "carousel" &&
        widget?.normal_carousel === true &&
        widget?.type === "widget_recommended" && (
          <Swiper
            spaceBetween={10}
            slidesPerView={2.5}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 6,
              },
            }}
          >
            {widget?.items?.[0]?.items?.map((item, index) => (
              <SwiperSlide key={item.product_id}>
                <SingleProducts
                  scroll={true}
                  item={item}
                  sort_order={index + 1}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}

      {widget?.display === "carousel" &&
        widget.type === "widget_recommended" &&
        widget.normal_carousel === false && (() => {
          const item = widget.items[0];
          const bar_title = item.bar_title;
          const bar_font_size = `${item.bar_font_size}px`;
          const bar_font_color=item.bar_font_color;
          const bar_background_color=item.bar_background_color; 
          return(
            <div   className="px-10 text-start mt-5">

<div
            style={{
              backgroundImage: `linear-gradient( 
                ${hexToRgba(item.background_color_secondary, 0.7)}, 
                ${hexToRgba(item.background_color_primary, 0.7)})`,
            }}
            className="px-2"
            >
              <div className="px-2">
                <div className="flex justify-between w-full">
                  <h1
                    style={{
                      color: item.font_color,
                      fontWeight: "900",
                    }}
                    className="text-[1rem] mt-1"
                  >
                    {item.title}
                  </h1>
                  <Link
                    to={`/${item.type}/${item.type_id}`}
                    onClick={() =>
                      dispatchAccount({
                        type: "setCarouselBannerRecommendedID",
                        payload:
                          item.banner_recommended_id,
                      })
                    }
                  >
                    <span className="cursor-pointer ml-4 text-[1rem] ">
                      View More &gt;
                    </span>
                  </Link>
                </div>

                <p className="mb-1" style={{ fontSize: "14px" }}>
                  {item.description}
                </p>
              </div>
              
              <Swiper
                spaceBetween={10}
                slidesPerView={6 + 0.5}
                slidesPerGroup={
                  maincategoriesSetting.slidesToScroll
                }
                onSlideChange={handleBeforeChange}
                onSlideChangeTransitionEnd={handleAfterChange}
                className="px-1 "
              >
                {item.items
                  ?.reduce((rows, item, index) => {
                    const rowIndex = Math.floor(
                      index / widget.row_number
                    );
                    if (!rows[rowIndex]) rows[rowIndex] = [];
                    rows[rowIndex].push(item);
                    return rows;
                  }, [])
                  .map((rowItems, rowIndex) => (
                    <SwiperSlide key={rowIndex}>
                      <div className="slide-row">
                        {rowItems.map((item) => (
                            <div key={item.product_id} style={{ position: 'relative', display: 'inline-block' }}>
                                <Link
                              to={`/product/${item.product_id}`}
                            ><img src={item.thumb} /></Link>
                            
                            {bar_title !== "" && (
                           <span
                             style={{
                               position: 'absolute', 
                               left: 0,
                               right: 0,
                               fontSize: bar_font_size,
                               color: bar_font_color,
                               backgroundColor: bar_background_color,
                               padding: '2px 4px',
                               minHeight: '1.2em',
                               lineHeight: '1.2em',
                               whiteSpace: 'nowrap',
                               overflow: 'hidden',
                               textOverflow: 'ellipsis',
                               pointerEvents: 'none',
                              transform:"translateY(-90%)"
                             }}
                           >
                             {bar_title}
                           </span>
                         )}
                          
                          <h1 className="text-lg">{item.special}</h1>
                          </div>
                          
                            
                        
                        ))}
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>

            </div>
           
          )
           })()}

{widget?.display === "grid" &&
        widget.type === "widget_recommended" &&
        widget.normal_carousel === false &&
        widget.items?.length > 0 && (
          <div className="flex gap-2 px-12">
           {widget.items[0] && (() => {
            const item = widget.items[0];
            const bar_title = item.bar_title;
            const bar_font_size = width>650 ? `${item.bar_font_size}px` : `${item.bar_font_size/1.2}px`;
            const bar_font_color=item.bar_font_color;
            const bar_background_color=item.bar_background_color;

            return (
              <div
                style={{
                  backgroundImage: `linear-gradient(to bottom, 
                    ${hexToRgba(item.background_color_secondary, 0.7)}, 
                    ${hexToRgba(item.background_color_primary, 0.7)})`,
                }}
                onClick={() => {
                  router(`/${item.type}/${item.type_id}`);
                  dispatchAccount({
                    type: "setGrid1BannerRecommendedID",
                    payload: item.banner_recommended_id,
                  });
                }}
                className="cursor-pointer"
              >
                <div className="px-2">
                  <div className="flex justify-between w-full">
                    <h2
                      style={{
                        color: item.font_color,
                        fontWeight: "900",
                      }}
                      className="text-[0.71rem] lg:text-lg"
                    >
                      {item.title}
                    </h2>
                    <span className="cursor-pointer ml-4 text-[0.60rem] mb-1 mr-1 lg:text-lg">
                      &gt;
                    </span>
                  </div>
                  <p className="mb-1 lg:text-sm text-start" style={{ fontSize: "10px" }}>
                    {item.description}
                  </p>
                </div>

                <div className="flex gap-2 px-2 text-start">
                  {item.items?.slice(0, 2).map((product) => (
                   <div key={product.product_id} style={{ position: 'relative', display: 'inline-block' }}>
                   <img src={product.thumb} />
                   {bar_title !== "" && (
                  <span
                    style={{
                      position: 'absolute', 
                      left: 0,
                      right: 0,
                      fontSize: bar_font_size,
                      color: bar_font_color,
                      backgroundColor: bar_background_color,
                      padding: '1px 4px',
                      minHeight: '1.2em',
                      lineHeight: '1.2em',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      pointerEvents: 'none',
                     transform:"translateY(-90%)"
                    }}
                  >
                    {bar_title}
                  </span>
                )}
                 
                   <span className="lg:text-lg">{product.special}</span>
                 </div>
                 
                  ))}
                </div>
              </div>
            );
          })()}


         {widget.items[1] && (() => {
            const item = widget.items[1];
            const bar_title = item.bar_title;
            const bar_font_size = width>650 ? `${item.bar_font_size}px` : `${item.bar_font_size/1.2}px`;
            const bar_font_color=item.bar_font_color;
            const bar_background_color=item.bar_background_color;

            return (
              <div
                style={{
                  backgroundImage: `linear-gradient(to bottom, 
                    ${hexToRgba(item.background_color_secondary, 0.7)}, 
                    ${hexToRgba(item.background_color_primary, 0.7)})`,
                }}
                onClick={() => {
                  router(`/${item.type}/${item.type_id}`);
                  dispatchAccount({
                    type: "setGrid2BannerRecommendedID",
                    payload: item.banner_recommended_id,
                  });
                }}
                className="cursor-pointer"
              >
                <div className="px-2">
                  <div className="flex justify-between w-full">
                    <h2
                      style={{
                        color: item.font_color,
                        fontWeight: "900",
                      }}
                      className="text-[0.71rem] lg:text-lg"
                    >
                      {item.title}
                    </h2>
                    <span className="cursor-pointer ml-4 text-[0.60rem] mb-1 mr-1 lg:text-lg">
                      &gt;
                    </span>
                  </div>
                  <p className="mb-1 lg:text-sm text-start" style={{ fontSize: "10px" }}>
                    {item.description}
                  </p>
                </div>

                <div className="flex gap-2 px-2 text-start">
                  {item.items?.slice(0, 2).map((product) => (
                   <div key={product.product_id} style={{ position: 'relative', display: 'inline-block' }}>
                   <img src={product.thumb} />
                   {bar_title !== "" && (
                  <span
                    style={{
                      position: 'absolute', 
                      left: 0,
                      right: 0,
                      fontSize: bar_font_size,
                      color: bar_font_color,
                      backgroundColor: bar_background_color,
                      padding: '1px 4px',
                      minHeight: '1.2em',
                      lineHeight: '1.2em',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      pointerEvents: 'none',
                     transform:"translateY(-90%)"
                    }}
                  >
                    {bar_title}
                  </span>
                )}
                 
                   <span className="lg:text-lg">{product.special}</span>
                 </div>
                 
                  ))}
                </div>
              </div>
            );
          })()}


         {widget.items[2] && (() => {
            const item = widget.items[2];
            const bar_title = item.bar_title;
            const bar_font_size = width>650 ? `${item.bar_font_size}px` : `${item.bar_font_size/1.2}px`;
            const bar_font_color=item.bar_font_color;
            const bar_background_color=item.bar_background_color;

            return (
              <div
                style={{
                  backgroundImage: `linear-gradient(to bottom, 
                    ${hexToRgba(item.background_color_secondary, 0.7)}, 
                    ${hexToRgba(item.background_color_primary, 0.7)})`,
                }}
                onClick={() => {
                  router(`/${item.type}/${item.type_id}`);
                  dispatchAccount({
                    type: "setGrid3BannerRecommendedID",
                    payload: item.banner_recommended_id,
                  });
                }}
                className="cursor-pointer"
              >
                <div className="px-2">
                  <div className="flex justify-between w-full">
                    <h2
                      style={{
                        color: item.font_color,
                        fontWeight: "900",
                      }}
                      className="text-[0.71rem] lg:text-lg"
                    >
                      {item.title}
                    </h2>
                    <span className="cursor-pointer ml-4 text-[0.60rem] mb-1 mr-1 lg:text-lg">
                      &gt;
                    </span>
                  </div>
                  <p className="mb-1 lg:text-sm text-start" style={{ fontSize: "10px" }}>
                    {item.description}
                  </p>
                </div>

                <div className="flex gap-2 px-2 text-start">
                  {item.items?.slice(0, 2).map((product) => (
                   <div key={product.product_id} style={{ position: 'relative', display: 'inline-block' }}>
                   <img src={product.thumb} />
                   {bar_title !== "" && (
                  <span
                    style={{
                      position: 'absolute', 
                      left: 0,
                      right: 0,
                      fontSize: bar_font_size,
                      color: bar_font_color,
                      backgroundColor: bar_background_color,
                      padding: '2px 4px',
                      minHeight: '1.2em',
                      lineHeight: '1.2em',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      pointerEvents: 'none',
                     transform:"translateY(-90%)"
                    }}
                  >
                    {bar_title}
                  </span>
                )}
                 
                   <span className="lg:text-lg">{product.special}</span>
                 </div>
                 
                  ))}
                </div>
              </div>
            );
          })()}

          </div>
        )}


      {widget.display === "grid" &&
        widget.items.length < 2 &&
        widget?.items?.map((item, index) =>
          item.mobile_type_id !== "0" ? (
            <Link
              to={
                // accountState.admin
                //   ? `${path}/${types[item.mobile_type]}/${item?.mobile_type_id}`
                //   :
                item?.name?.length > 0
                  ? "/" +
                    item?.name
                      ?.replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                      .replace("%", "")
                      .replace(/\s+/g, "-")
                      .replace("/", "-") +
                    "/" +
                    types[item?.mobile_type]?.slice(0, 1) +
                    "=" +
                    item?.mobile_type_id
                  : "cat/c=" + item?.mobile_type_id
              }
              state={{
                banner_id: item.banner_id,
                banner_image_id: item.banner_image_id,
                source_type: source_type,
                source_type_id: source_type_id,
              }}
            >
              <LazyLoadImage
                className="w-full"
                alt={item.name}
                src={`https://www.englishhome.com.lb/image/` + item.image}
                width={item.banner_width ? item.banner_width : 265}
                height={item.banner_height ? item.banner_height : 265}
                title={item.name}
              />
            </Link>
          ) : (
            <div key={index}>
              <LazyLoadImage
                className="w-full"
                src={"https://www.englishhome.com.lb/image/" + item.image}
                alt={item.name}
                height={item.banner_height ? item.banner_height : 265}
              />
            </div>
          )
        )}
    </div>
  );
}

export default WidgetsLoop;
